export interface IRemoteReservationResponse {
  id: number;
  reservationId: number;
  employeeName: string;
  employeeSurname: string;
  email: string;
  requestDate: Date;
  reservationDate: Date;
  reservationStatusId: number;
  notificationCount:string;
  reservationMonth:string;
  totalReservationsInMonth:number;

}
export interface IChangeReservationRequest {
  id: number;
  reservationId: number;
  managerId: number;
  statusId: number;
  rejectionExplanation:string

}
export type ReservationStatus = 1 | 2 | 3
export enum EReservationStatus {
  PendingApproval = 1,
  Approved = 2,
  Rejected = 3,
}
